(function () {
  'use strict';

  // ---------- Price display update ----------
  function updateCardPrice(card, priceDisplay, comparePriceDisplay, comparePriceInt, priceInt) {
    var priceDiv = card.querySelector('.price');
    var priceContainer = card.querySelector('.price-container');
    if (!priceContainer || !priceDiv) return;

    var isOnSale = comparePriceInt > priceInt;

    if (isOnSale) {
      priceDiv.classList.add('price--on-sale');
      priceContainer.innerHTML =
        '<span class="price-item price-item--sale" dir="ltr">' + priceDisplay + '</span>' +
        '<s class="price-item price-item--regular" dir="ltr">' + comparePriceDisplay + '</s>';
    } else {
      priceDiv.classList.remove('price--on-sale');
      priceContainer.innerHTML =
        '<span class="price-item price-item--regular" dir="ltr">' + priceDisplay + '</span>';
    }
  }

  // ---------- Variant select change ----------
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select.classList.contains('card-variant-picker')) return;

    var card = select.closest('.card');
    var cardWrapper = select.closest('.card-wrapper');
    if (!card) return;

    var option = select.options[select.selectedIndex];
    var priceDisplay = option.dataset.priceDisplay || '';
    var comparePriceDisplay = option.dataset.comparePriceDisplay || '';
    var comparePriceInt = parseInt(option.dataset.comparePriceInt || '0', 10);
    var priceInt = parseInt(option.dataset.priceInt || '0', 10);
    var available = option.dataset.available !== 'false';

    // Update price
    updateCardPrice(card, priceDisplay, comparePriceDisplay, comparePriceInt, priceInt);

    // Sync ATC button
    var atcBtn = (cardWrapper || card).querySelector('.card-atc-direct');
    if (atcBtn) {
      atcBtn.dataset.variantId = select.value;
      var btnSpan = atcBtn.querySelector('span.loading-hidden');
      if (!available) {
        atcBtn.disabled = true;
        if (btnSpan) btnSpan.textContent = 'SOLD OUT';
      } else {
        atcBtn.disabled = false;
        if (btnSpan) btnSpan.textContent = 'ADD TO CART';
      }
    }
  });

  // ---------- Direct Add to Cart ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-atc-direct');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    e.preventDefault();

    var btnSpan = btn.querySelector('span.loading-hidden');
    var originalText = btnSpan ? btnSpan.textContent.trim() : 'ADD TO CART';

    btn.classList.add('loading');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Build sections list — always include cart icon bubble; add cart drawer if present
    var cartDrawer = document.getElementById('Cart-Drawer');
    var sectionsToFetch = ['cart-icon-bubble'];
    if (cartDrawer && !cartDrawer.hasAttribute('data-status-silence')) {
      sectionsToFetch.push(cartDrawer.dataset.section);
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: sectionsToFetch })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Add failed'); });
        return res.json();
      })
      .then(function (data) {
        btn.classList.remove('loading');
        if (btnSpan) btnSpan.textContent = originalText;

        var parser = new DOMParser();

        // Update cart icon bubble
        if (data.sections && data.sections['cart-icon-bubble']) {
          var doc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var newContent = doc.querySelector('.shopify-section') || doc.body;
          var existing = document.getElementById('Cart-Icon-Bubble');
          if (newContent && existing) existing.innerHTML = newContent.innerHTML;
        }

        // Update cart drawer content and open it
        if (cartDrawer && !cartDrawer.hasAttribute('data-status-silence')) {
          var drawerSectionKey = cartDrawer.dataset.section;
          if (data.sections && data.sections[drawerSectionKey]) {
            var drawerDoc = parser.parseFromString(data.sections[drawerSectionKey], 'text/html');
            var newDrawerDetails = drawerDoc.getElementById('Cart-Drawer-Details');
            var existingDrawerDetails = document.getElementById('Cart-Drawer-Details');
            if (newDrawerDetails && existingDrawerDetails) {
              existingDrawerDetails.innerHTML = newDrawerDetails.innerHTML;
            }
          }
          cartDrawer.show(btn);
        }

        // Notify theme's cart system
        if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: data
          });
        }
      })
      .catch(function (err) {
        btn.classList.remove('loading');
        if (btnSpan) btnSpan.textContent = 'Error — try again';
        console.error('[card-atc]', err);
        setTimeout(function () {
          if (btnSpan) btnSpan.textContent = originalText;
        }, 2500);
      });
  });
})();
